import { GET_ANALYSIS, GET_ANALYSIS_ERR } from '../../actionTypes/leadType'
import { getAnalysisApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getAnalysis = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getAnalysisApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_ANALYSIS,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_ANALYSIS_ERR,
            payload: error && error.response
        });
    }
}


